/**
 * AI Usage API Client
 * Talks to the payment-service backend /admin/ai-usage endpoints using JWT from auth-service
 */

import { isProxied } from '../proxy-config';

const BILLING_API = isProxied ? '' : (process.env.REACT_APP_BILLING_API_URL || 'http://localhost:5020');

class AiUsageApiClient {
  getToken() {
    return localStorage.getItem('billing-access-token');
  }

  async request(path, options = {}) {
    const url = `${BILLING_API}${path}`;
    const headers = { 'Content-Type': 'application/json', ...options.headers };

    const token = this.getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const response = await fetch(url, { ...options, headers });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      const error = new Error(data.error || data.message || 'Request failed');
      error.status = response.status;
      error.data = data;
      throw error;
    }

    return response.json();
  }

  get(path, params = {}) {
    const url = new URL(path, BILLING_API || window.location.origin);
    Object.entries(params).forEach(([k, v]) => {
      if (v != null) url.searchParams.set(k, v);
    });
    return this.request(url.toString().replace(BILLING_API || window.location.origin, ''));
  }

  post(path, body) {
    return this.request(path, { method: 'POST', body: JSON.stringify(body) });
  }
}

const _client = new AiUsageApiClient();

export const aiUsageApi = {
  getSummary: (params) => _client.get('/api/admin/ai-usage/summary', params),
  getTimeseries: (params) => _client.get('/api/admin/ai-usage/timeseries', params),
  getBreakdownByApp: (params) => _client.get('/api/admin/ai-usage/breakdown/app', params),
  getBreakdownByUseCase: (params) => _client.get('/api/admin/ai-usage/breakdown/use-case', params),
  getBreakdownByUser: (params) => _client.get('/api/admin/ai-usage/breakdown/user', params),
  getFilterOptions: () => _client.get('/api/admin/ai-usage/filter-options'),
  getPricing: () => _client.get('/api/admin/ai-usage/pricing'),
  addPricingRate: (body) => _client.post('/api/admin/ai-usage/pricing', body),
};

export default aiUsageApi;
